import { LocalOperation } from 'hooks/store/types';
import { useDispatch } from 'hooks/utils';
import { addFormElement, AddFormElementAction } from 'store/data/forms';
import { ActionPayload } from 'store/types';

export function useAddFormElement(): LocalOperation<
	(payload: ActionPayload<AddFormElementAction>) => void
> {
	const dispatch = useDispatch();

	function handler(payload: ActionPayload<AddFormElementAction>) {
		dispatch(addFormElement(payload));
	}

	return handler;
}
